export function filterFilesByYears() {
    const sortBtn = document.querySelector('.filter-menu')?.children,
          sortItem = document.querySelector('.filter-item')?.children,
          nothing = document.querySelector('.nothing')?.classList;

    if(!sortBtn && !sortItem) return

    for(let i = 0; i < sortBtn.length; i++) {
        sortBtn[i].addEventListener('click', function() {
            for(let j = 0; j< sortBtn.length; j++){
                sortBtn[j].classList.remove('current');
            };

            this.classList.add('current');
            
            let targetData = this.getAttribute('data-target'),
                count = false;

            for(let k = 0; k < sortItem.length; k++) {
                sortItem[k].classList.remove('active');
                sortItem[k].classList.add('delete');

                sortItem[k].getAttribute('data-item').includes(targetData) ? count = true : '' 

                if(sortItem[k].getAttribute('data-item') == targetData || targetData == "all"){
                    sortItem[k].classList.remove('delete');
                    sortItem[k].classList.add('active');
                }
            }

            count ? nothing.remove('show') : nothing.add('show');
        });
    };
};
